import { AmazingCareLogo } from "@/components/amazing-care-logo";
import { AnimatedOutlet } from "@/components/animated-outlet";
import { ThemeToggle } from "@/components/theme-toggle";

export function AuthLayout() {
  return (
    <div className="flex min-h-screen flex-col bg-background text-foreground">
      <header className="flex items-center justify-between px-6 py-4">
        <AmazingCareLogo className="h-9 w-auto object-contain" />
        <ThemeToggle />
      </header>
      <main className="flex flex-1 items-center justify-center px-6 pb-16">
        <AnimatedOutlet className="flex w-full justify-center" />
      </main>
    </div>
  );
}
